import { createSelector } from '@reduxjs/toolkit';

import { projectModelsByIdSelector } from 'src/selectors/projectModelsById';

export const projectModelSelector = (projectId: string, id: string) =>
  createSelector(
    projectModelsByIdSelector(projectId),
    (modelsById) => modelsById[id] || null
  );
